/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * The CMS API!
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { ContinueWatchingUIModuleContentTreatment } from './continue-watching-uimodule-content-treatment';
import { ContinueWatchingUIModuleContentType } from './continue-watching-uimodule-content-type';
import { EntitlementType } from './entitlement-type';
import { LocalizedFieldBody } from './localized-field-body';
import { TargetPlatform } from './target-platform';
import { UiModuleExperimentGroup } from './ui-module-experiment-group';

/**
 * 
 * @export
 * @interface ContinueWatchingUiModuleBody
 */
export interface ContinueWatchingUiModuleBody {
    /**
     * 
     * @type {string}
     * @memberof ContinueWatchingUiModuleBody
     */
    moduleId?: string;
    /**
     * 
     * @type {string}
     * @memberof ContinueWatchingUiModuleBody
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof ContinueWatchingUiModuleBody
     */
    hash?: string;
    /**
     * 
     * @type {string}
     * @memberof ContinueWatchingUiModuleBody
     */
    moduleType: ContinueWatchingUiModuleBodyModuleTypeEnum;
    /**
     * 
     * @type {Array<TargetPlatform>}
     * @memberof ContinueWatchingUiModuleBody
     */
    targetPlatform?: Array<TargetPlatform>;
    /**
     * 
     * @type {LocalizedFieldBody}
     * @memberof ContinueWatchingUiModuleBody
     */
    caption?: LocalizedFieldBody;
    /**
     * 
     * @type {Array<EntitlementType>}
     * @memberof ContinueWatchingUiModuleBody
     */
    entitlements?: Array<EntitlementType>;
    /**
     * 
     * @type {Array<UiModuleExperimentGroup>}
     * @memberof ContinueWatchingUiModuleBody
     */
    experiments?: Array<UiModuleExperimentGroup> | null;
    /**
     * 
     * @type {LocalizedFieldBody}
     * @memberof ContinueWatchingUiModuleBody
     */
    title: LocalizedFieldBody;
    /**
     * 
     * @type {ContinueWatchingUIModuleContentTreatment}
     * @memberof ContinueWatchingUiModuleBody
     */
    contentTreatment: ContinueWatchingUIModuleContentTreatment;
    /**
     * 
     * @type {ContinueWatchingUIModuleContentType}
     * @memberof ContinueWatchingUiModuleBody
     */
    contentType: ContinueWatchingUIModuleContentType;
}

/**
    * @export
    * @enum {string}
    */
export enum ContinueWatchingUiModuleBodyModuleTypeEnum {
    CONTINUE_WATCHING = 'CONTINUE_WATCHING'
}



